import BaseApiService from './BaseApiService';

class LearnerApiService extends BaseApiService {
  /**
   * Get courses for the current learner
   * @param {Object} params - { page, pageSize, search }
   * @returns {Promise<{courses: Array, pagination: Object}>}
   */
  getMyCourses = async ({ page = 1, limit = 8, search = '' } = {}) => {
    try {
      const response = await this.getAxiosInstance().get('/learner/my-courses', {
        params: {
          page,
          limit,
          search: search.trim(),
        },
      });
      const data = response.data?.data || {};
      return {
        courses: Array.isArray(data.courses) ? data.courses : [],
        pagination: typeof data.pagination === 'object' && data.pagination !== null ? data.pagination : {},
      };
    } catch (error) {
      console.error('Error fetching learner courses:', error);
      return { courses: [], pagination: {} };
    }
  };
}

export default new LearnerApiService(); 